import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Popup, Position } from 'devextreme-react/popup';
import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    RequiredRule,
    Label,
  } from 'devextreme-react/form';

import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box'; 
import { persianLanguage } from '../../../../constants/persianTerms';
import { useAuth } from '../../auth-provider/auth-provider';
import { BASE_API } from '../../../../constants/api';
import axios from 'axios';
import { persianPrice } from '../../../../shared/persian-number';
import { errorNotify } from '../../../../shared/notifications';
import { Bounce, ToastContainer } from 'react-toastify';

const submitButtonOptions = {
  text: persianLanguage.word.general.ENTER,
  useSubmitBehavior: true,
  stylingMode: "outlined",
  width: '100%',
};  

const retryButtonOptions = {
  text: 'دریافت مجدد کد تایید',
  useSubmitBehavior: false,
  stylingMode: "outlined",
  width: '100%',
};  

const colCountByScreen = {
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
};

export default function OTPLogin(props){
    const formRef = useRef(null);
    const auth = useAuth();
    
    const [remaininExpiration, setRemaininExpiration] = useState(300);
    const [popupVisible,  setPopupVisible] = useState(props.popupValue);
    const [mobile, setMobile] = useState(props.mobile);
    const [incorrectOTP, setIncorrectOTP] = useState(false);
    const [positionOf, setPositionOf] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);

    const [formData, setFormData] = useState({
      "otp": "",
      "mobile": props.mobile,
    })

    // Step 2: useEffect to set up an interval that increments the counter
  // useEffect(() => {

  //   if (remaininExpiration < 1){
  //     hideInfo();
  //   }

  //   // Create a timer to decrement the remaininExpiration every second
  //   const remainingDecrease = setInterval(() => {
  //     setRemaininExpiration(prevRemaininExpiration => prevRemaininExpiration - 1);

  //   }, 1000);

  //   // Cleanup the interval when the component unmounts to prevent memory leaks
  //   return () => clearInterval(remainingDecrease);
  // }, [remaininExpiration]); // Empty dependency array means this effect runs only on component mount


  // Step 3: Handle form input changes
  const handleChange = (e) => {
    formData.otp = e.value;
  };
  
    useEffect(() => {
      formData.mobile = props.mobile;
      setMobile(props.mobile);
      getOTPExpiration();
    }, [props.mobile]);

    useEffect(() => {
      setPopupVisible(props.popupValue);
    },[props.popupValue]);

    const handleSubmit = async (e) => {
      setIsDisabled(true);
      e.preventDefault();
      // console.log('fo: ', formData)
      // auth.otpLoginAction(formData);
      // if(auth.token){
      //   props.popupToParent(false);
      //   props.mobileToParent(props.mobile);
      //   setIsDisabled(false);
      // } else {
      //   setIncorrectOTP(true);
      //   setIsDisabled(false);
      // }
      try {
        const res = await auth.otpLoginAction(formData);
        props.popupToParent(false);
        props.mobileToParent(props.mobile);
        setIsDisabled(false);
      } catch (error) {
        setIncorrectOTP(true);
        setIsDisabled(false);
        if(error.response){
            if(error.response.status === 400){
                errorNotify(persianLanguage.phrase.error.ERROR_400);
            } else if(error.response.status === 401){
                errorNotify(persianLanguage.phrase.error.ERROR_401);
            } else if(error.response.status === 403){
                errorNotify(persianLanguage.phrase.error.ERROR_403);
            }else if(error.response.status === 404){
                errorNotify(persianLanguage.phrase.error.ERROR_404);
            }else if(error.response.status === 412){
                errorNotify('عدم همخوانی اطلاعات ارسالی');
            }
        }
      }
    };
    

    const hideInfo = () => {
      props.mobileToParent(mobile);
      setFormData({
        "otp": "",
        "mobile": props.mobile,
      });
      setPopupVisible(false);
      props.popupToParent(false);
    };

    const onOptionChanged = useCallback();

    const getOTPExpiration = () => {
      const api = `${BASE_API}otp/expiration/`;
      axios.get(api).then(
        response => {
          setRemaininExpiration(60 * response.data['otpExpiration']);
        }
      ).catch(
        error => {
          setRemaininExpiration(60 * 5);
        }
      );
    }

    const handleRetry = () => {

    }

  // Submit OTP directly
  const submitOTP = async (otpCode) => {
    setIsDisabled(true);
    try {
      await auth.otpLoginAction({ mobile, otp: otpCode });
      setIncorrectOTP(false);
      hideInfo();
    } catch (error) {
      setIncorrectOTP(true);
      if (error.response) {
        if (error.response.status === 400) errorNotify(persianLanguage.phrase.error.ERROR_400);
        else if (error.response.status === 401) errorNotify(persianLanguage.phrase.error.ERROR_401);
        else if (error.response.status === 403) errorNotify(persianLanguage.phrase.error.ERROR_403);
        else if (error.response.status === 404) errorNotify(persianLanguage.phrase.error.ERROR_404);
        else if (error.response.status === 412) errorNotify('عدم همخوانی اطلاعات ارسالی');
      }
    } finally {
      setIsDisabled(false);
    }
  };


  // AUTO READ OTP (Android Chrome) + Autofill (iOS)
  useEffect(() => {
    if (!popupVisible) return;

    // Focus OTP input inside DevExtreme form
    setTimeout(() => {
      const input = document.querySelector("input[name='otp']");
      input?.focus();
    }, 100);

    // ---- ANDROID: Web OTP API ----
    if ("OTPCredential" in window) {
      const ac = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          if (otp?.code) {
            setFormData(prev => ({ ...prev, otp: otp.code }));

            const fakeEvent = { preventDefault: () => {} };
            setTimeout(() => {
              submitOTP(otp?.code);
            }, 10);

          }
        })
        .catch(() => {});

      // Cleanup if popup closes
      return () => ac.abort();
    }

    // ---- iOS Safari ----
    // Safari reads the OTP if input has autocomplete="one-time-code"
  }, [popupVisible]);

    return (
        <>
          <ToastContainer
            rtl={true}
            position="top-center"
            theme="dark"
            draggable
            transition={Bounce} 
          />
          <Popup
            visible={popupVisible}
            onHiding={hideInfo}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            rtlEnabled={true}
            showTitle={true}
            resizeEnabled={true}
            title={`${persianLanguage.phrase.required.ENTER_OTP_CODE}`}
            width={310}
            height={250}
            >
              <form onSubmit={handleSubmit}>

              <div className="row justify-content-center">
                <p className="text-center p-1 ">
                  زمان باقی مانده:
                  <span className='px-3 '>
                    {persianPrice(remaininExpiration)}
                  </span>
                  </p>
              </div>

                <Form
                  ref={formRef}
                  formData={formData}
                  labelMode="floating"
                  readOnly={false}
                  onOptionChanged={onOptionChanged}
                  showColonAfterLabel={true}
                  showValidationSummary={true}
                >   
                <GroupItem 
                // caption={persianLanguage.word.general.ENTER}
                >
                <SimpleItem dataField="otp" 
                  editorType="dxTextBox" 
                  cssClass='bg-primary-main'
                  editorOptions={{
                    valueChangeEvent: 'keyup',
                    onValueChanged: (e, name) => handleChange(e, name),
                    inputAttr: {
                      autocomplete: "one-time-code",    // iOS
                      class: 'bg-primary-main',
                      inputMode: "numeric",
                    },
                  }}>
                    <Label text={persianLanguage.word.auth.OTP}/>
                    <RequiredRule 
                    message={persianLanguage.phrase.required.OTP_REQUIRED} />
                </SimpleItem>
                </GroupItem>    
                <GroupItem cssClass=" buttons-group no-border-btn" colCountByScreen={colCountByScreen}>
                <ButtonItem 
                  cssClass='bg-success-main otp-submit-btn no-border-btn rounded-[24px]' 
                  onClick={handleSubmit}
                  disabled={isDisabled}
                  buttonOptions={submitButtonOptions} />

                {/* <ButtonItem onClick={handleRetry}
                buttonOptions={retryButtonOptions} /> */}
                </GroupItem>
                
                </Form>
                {incorrectOTP && 
              <p className='text-center  border border-red-400 text-red-700 m-5 pt-0 px-1 py-1 rounded' >
                دوباره تلاش کنید
              </p>
              }
              </form>
              
            <Position at="center" my="center" of={positionOf} collision="fit" />
          </Popup>
        </>
      );    
}